/** Shown wherever prices or payment totals come from the last processed claim while newer HL7 data is processing. */
export const PENDING_PRICES_MESSAGE =
    'Updated claim data is processing. Prices and payment totals show the last processed version until processing finishes.';
